import { bonusPromotionsActions } from '../../../store/slices/bonusPromotions/slice';
import { ChipTypes } from '../../../store/slices/chips/types';
import { gameStateActions } from '../../../store/slices/game/slice';
import { GameStatus } from '../../../store/slices/game/types';
import { toastActions } from '../../../store/slices/toast/slice';
import { roundNumber } from '../../../utils/number';
import { type GameCommunicationMessageType, MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

// Message example
// {"canceled":{"id":"186742501","cancelReason":"Flapper issue","cancelCode":"1041","seq":13}}

export class CoreCancelledGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.Canceled;

  public process(_message: GameCommunicationMessageType): void {
    const state = this.store.getState();
    const isFreeChip = state.bets.placedBetType === ChipTypes.FreeChip;
    const totalBet = state.bets.totalBet;
    const freeChipValue = state.bonusPromotions.activeBonusCampaign?.bonus.chipValue ?? 0;
    const freeChipRefundedCount = roundNumber(totalBet / freeChipValue, 0);
    if (isFreeChip && freeChipValue > 0) {
      this.store.dispatch(
        toastActions.createDynamicToast({
          message: 'TOAST_FREE_CHIPS_REFUNDED',
          msgDynamicValues: [String(freeChipRefundedCount)],
        })
      );
    }
    if (!state.config?.tableConfig?.isAutomatedMessagesEnabled) {
      this.store.dispatch(toastActions.createToast('TOAST_GAME_CANCELLED'));
    }
    this.store.dispatch(gameStateActions.setCurrentGameStatus(GameStatus.GameCancelled));
    const isEligibleCampaign = Boolean(this.store.getState().bonusPromotions.eligibleBonusCampaign);
    if (isEligibleCampaign) {
      this.store.dispatch(bonusPromotionsActions.setRefetchCampaign(true));
    }
  }
}
